import { formatLargeNumber } from '../../../../utility/formatNumbers';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../../../../firebase/clientApp';
import { GRAPHS, PROPERTIES, USERS } from '../../../../../firebase/utility';

export const getScenarioColor = (scenarioName) => {
  if (scenarioName === 'BRRRR Scenario') {
    return '#1378F7';
  }
  if (scenarioName === 'Buy and Hold') {
    return '#15803D';
  }
  return '#9ca3af';
};

export const yearRowIsValid = (yearRow) => {
  return Object.values(yearRow).every(
    (value) => typeof value === 'string' || !isNaN(value)
  );
};

export const valueFormatter = (value, unit) => {
  if (value !== 0) {
    return unit === '$' ? `$${formatLargeNumber(value)}` : `${value}${unit}`;
  }
  return value;
};

export const updateScenarioGraph = async (userId, propertyId, type, svg) => {
  const pathToDoc = `${USERS}/${userId}/${PROPERTIES}/${propertyId}/${GRAPHS}`;
  await setDoc(doc(db, pathToDoc, type), { scenarioGraphSvg: svg });
};
